import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { saveAuthData, clearAuthData, isAuthenticated as checkAuth } from '../services/authService';
import { loginAndSaveToken } from '../pages/Login/Service';

interface AuthContextType {
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  setIsLoggedIn: (status: boolean) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(checkAuth());

  // Kiểm tra trạng thái xác thực khi component được mount
  useEffect(() => {
    setIsAuthenticated(checkAuth());
  }, []);

  const login = async (username: string, password: string): Promise<boolean> => {
    try {
      const response = await loginAndSaveToken({ username, password });
      
      if (response.result === 'SUCCESS' && response.data) {
        // Token đã được lưu vào localStorage trong hàm loginAndSaveToken
        
        // Cập nhật state
        setIsAuthenticated(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Lỗi đăng nhập:', error);
      return false;
    }
  };

  const logout = () => {
    clearAuthData();
    setIsAuthenticated(false);
  };
  
  const setIsLoggedIn = (status: boolean) => {
    setIsAuthenticated(status);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, setIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;